import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./styles.scss";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./app/store";
import "./locales/i18n";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { trTR } from "@mui/material/locale";

const theme = createTheme(
  {
    palette: {},
  },
  trTR
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
